











































import { Component, Vue, Watch } from 'vue-property-decorator';
import { goTop } from '@/global/utils';
import { readMsg, messageList, readAll } from '@/api/user/user';
import { isLogin } from "@/global/utils";
import { DOMAIN } from '@/global/constants';

@Component
export default class Message extends Vue {
  private columns: object[] = [
    {
      title: 'read',
      slot: 'read',
      width: 50,
    },
    {
      title: 'title',
      key: 'title',
      width: 150,
      tooltip: true,
    },
    {
      title: 'message',
      slot: 'message',
      tooltip: true,
    },
    {
      title: 'date',
      slot: 'date',
      align: 'right',
    },
  ];
  private data: object[] = [];
  private pageNum: number = 1;
  private total: number = 0;
  private modualTaskType = Object.freeze({
    1: 51,
    2: 52,
    3: 53,
    4: 54,
    5: 55,
    6: 56,
    7: 57,
    9: 52,
    10: 55
  });
  @Watch('$route')
  private routechange(to: any, from: any) {
    if (to.name == 'message') {
      this.getMessage();
    }
  }
  private async handleSelect(row) {
    const id = row.id;
    const type = row.type;
    const message = JSON.parse(row.message)
    const mid = message.mid;
    const lid = message.lid;
    const markType = message.type;
    const from = message.from;
    const title = row.title
    // 标记为已读
    const res = await readMsg({ id: id });
    // 更新最近5条消息
    this.$store.dispatch('getRecentList');
    // 跳转任务详情页
    if(title === '公会消息'){
        return;
    }else{
      if (type && (type == 2 || type == 1400)) {
        return;
      } else if(type && type == 2400){
        window.open("http://help.longmaosoft.com/forum.php?mod=viewthread&tid=862&page=1&extra=#pid3001", "_blank");
      } else if(lid) {
        this.openEditor({ mid, lid, from, markType })
      }else {
        this.$router.push({ path: `/task/crowd/detail/${mid}` });
      }
    }
  }
   // 重做做题 跳转页面
   private openEditor(data) {
    if (!isLogin(this)) {
      return;
    }
    let url = `${DOMAIN}/tools/`;
    if (/^sketch(-.+)?$/.test(data.from)) {
        const parts = data.from.split('-');
        url += `${parts.length > 1 ? parts[1] : 'markPage'}.html`;
    } else if (data.from) {
        url += data.from + '.html';
    } else {
        url += 'markPage.html';
    }
    url += `?type=${this.modualTaskType[data.markType]}&id=${data.mid}&lid=${data.lid}&version=2&stage=2`;
    window.open(url);
  }
  private created() {
    this.getMessage();
    goTop();
  }
  // 获取数据
  private async getMessage() {

    const res: any = await messageList({ page: this.pageNum });
    this.$nextTick(() => {
      this.data = res.rows;
      this.total = res.total;
    });
  }
  // 分页
  private changePageNum(num) {
    this.pageNum = num;
    this.getMessage();
  }
  // 全部标记为已读
  private async handleReadAll() {
    const res = await readAll({});
    // 更新任务列表
    this.pageNum = 1;
    this.getMessage();
    // 更新最近5条消息
    this.$store.dispatch('getRecentList');
  }

  private extractNumbersFromString(row){
    const title = row.title
    const type = row.type  == 2400 ? `<a>公会规范</a>` : ""
    const str = JSON.parse(row.message).title
    if(title === '公会消息'){
      const regex = /[\d,]+/g; // 匹配包含逗号的数字字符串
      const numbers = str.match(regex);
      if(numbers.length !== 0){
        let replacedString = str;
        numbers.forEach(s => {
          const linkCode = `<a href="#" class="copy-text">`+s+`</a>`;
          replacedString = replacedString.replace(s, linkCode);
        });
        return replacedString+type
      }else{
        return str+type
      }
    }else{
      return str+type
    }
  }
  private copyText(e) {
    if(Array.from(e.target.classList).includes('copy-text')){
        var textarea = document.createElement("textarea");
        textarea.value = e.target.innerText;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        this.$Message.success("复制成功");
    }
      
    }
}
